import { render, staticRenderFns } from "./ParticipationTerms.vue?vue&type=template&id=07f233d2&scoped=true&"
import script from "./ParticipationTerms.vue?vue&type=script&lang=js&"
export * from "./ParticipationTerms.vue?vue&type=script&lang=js&"
import style0 from "./ParticipationTerms.vue?vue&type=style&index=0&id=07f233d2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07f233d2",
  null
  
)

export default component.exports